window.addEventListener("load", (e) => {
    document.querySelectorAll('.block-flexible_filter').forEach((block) => {
        block.querySelectorAll('.filter-action-button').forEach((filter) => {
            filter.onclick = function (e) {
                if (filter.classList.contains('active')) {
                    filter.classList.remove('active');
                    block.dataset.filtered = 'false';

                    block.querySelectorAll('.item.active').forEach((i) => {
                        i.classList.remove('active');
                    })
                    if (block.querySelector('.filter-content .content.active')) {
                        block.querySelector('.filter-content .content.active').classList.remove('active');
                    }
                } else {
                    block.querySelectorAll('.filter-action-button.active').forEach((b) => {
                        b.classList.remove('active')
                    })
                    filter.classList.add('active');
                    block.dataset.filtered = 'true';

                    block.querySelectorAll('.item.active').forEach((i) => {
                        i.classList.remove('active');
                    })

                    block.querySelectorAll('.item[data-key="'+filter.dataset.key+'"]').forEach((i) => {
                        i.classList.add('active');
                    })
                    if (block.querySelector('.filter-content .content.active')) {
                        block.querySelector('.filter-content .content.active').classList.remove('active');
                    }
                    block.querySelector('.filter-content .content[data-key="'+filter.dataset.key+'"]').classList.add('active');
                }
            }
        })
    })
});